export default __webpack_public_path__ + "img/437c27ed5bb741df606482c8a9514033.svg";